import { Dispatch, Action } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { sumOrderTimes } from 'lib/order'
import { OrderTime } from 'types/checkout'
import { countOrderTimesAction } from 'reducks/checkout/actions'

const countOrderTimes = (userIds: string[], currentDate: Date, storeRefs: FirebaseDocRefType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    const orderTimes: OrderTime[] = []
    for (let i = 0; i < userIds.length; i = (i + 1) | 0) {
      const userId = userIds[i]
      const promises: Promise<number>[] = storeRefs.map((storeRef) => {
        return sumOrderTimes(currentDate, storeRef, userId)
      })
      const result = await Promise.all(promises)
      const times = result.reduce((prev, _times) => prev + _times, 0)
      orderTimes.push({ times: times, user_id: userId })
    }
    dispatch(countOrderTimesAction(orderTimes))
  }
}

export default countOrderTimes
